import React from 'react';
import { ArticleHeader } from '../components/ArticleHeader';
import { StoryColumn } from '../components/StoryColumn';
import { OfferSidebar } from '../components/OfferSidebar';
import { LegalFooter } from '../components/LegalFooter';
export function Advertorial() {
  return <div className="min-h-screen w-full bg-neutral-100 py-0 sm:py-8" data-id="element-57" data-mp="1jrijbfmw9oux">
      <main className="mx-auto w-full max-w-[1240px] overflow-hidden bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.04),0_10px_30px_rgba(0,0,0,0.06)] sm:rounded" data-id="element-58" data-mp="1jqqy8yqxb9iw">
        <ArticleHeader data-id="element-59" data-mp="r23beyqj0c38" />

        <div className="flex flex-col gap-7 px-5 pt-6 sm:px-8 lg:flex-row lg:gap-8" data-id="element-60" data-mp="r3ecurwi17r6">
          <StoryColumn data-id="element-61" data-mp="w0wlsiainmz6" />
          <OfferSidebar data-id="element-62" data-mp="w0myx3krpvxp" />
        </div>

        <LegalFooter data-id="element-63" data-mp="10sefqme4gnan" />
      </main>
    </div>;
}